import React from "react";
import { Link } from "react-router-dom";
import YouTubePlayer from "../components/YoutubePlayer";
import { Helmet } from "react-helmet";

import Navbar from "../components/navbar";
import Highlight from "../components/highlight";
import Point from "../components/point";
import Accordion from "../components/accordion";
import Feature from "../components/feature";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Hobby Connect</title>
        <meta name="description" content="Hobby Connect" />
        <meta property="og:title" content="Hobby Connect" />
        <meta property="og:description" content="Hobby Connect" />
      </Helmet>
      <div className="home-header">
        <Navbar></Navbar>
        <div className="home-hero">
          <div className="home-container1">
            <div className="home-content">
              <h1 className="home-title">Hobby Connect</h1>
              <span className="home-caption">
                Connect with like-minded people, effortlessly
              </span>
              <div className="home-hero-buttons">
                <div className="home-io-btn">
                  <img
                    alt="pastedImage"
                    src="/playground_assets/pastedimage-zmzg.svg"
                    className="home-apple"
                  />
                  <span className="home-caption1">
                    Download for iOS (not working)
                  </span>
                </div>
                <a
                  href="https://drive.google.com/file/d/16GS-vHQTlNL2SxX79-wNZJY7ViT2JVk8/view?usp=share_link"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link"
                >
                  <div className="home-android-btn">
                    <img
                      alt="pastedImage"
                      src="/playground_assets/pastedimage-ld65.svg"
                      className="home-android"
                    />
                    <span className="home-caption2">Download for Android</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="home-images">
            <div className="home-column">
              <img
                alt="pastedImage"
                src="/playground_assets/screenshot_2023-03-07-21-32-19-287_com.hobbyconnect1-800h.jpg"
                className="home-pasted-image"
              />
            </div>
            <div className="home-column1">
              <img
                alt="pastedImage"
                src="/playground_assets/screenshot_2023-03-07-21-32-17-313_com.hobbyconnect1-800h.jpg"
                className="home-pasted-image1"
              />
              <img
                alt="pastedImage"
                src="/playground_assets/screenshot_2023-03-07-21-27-37-190_com.hobbyconnect-800h.jpg"
                className="home-pasted-image2"
              />
            </div>
            <div className="home-column2">
              <img
                alt="pastedImage"
                src="/playground_assets/screenshot__519_-removebg-preview-800h.png"
                className="home-pasted-image3"
              />
              <img
                alt="pastedImage"
                src="/playground_assets/screenshot_2023-03-07-21-28-28-850_com.hobbyconnect1-800h.jpg"
                className="home-pasted-image4"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="home-video">
        <div className="home-content1">
          <div className="home-header1">
            <h2 className="home-text">
              <span className="home-text01">
                Built specifically for people who want to Connect with peoples
                have similar hobbies or Interests
              </span>
              <br className="home-text02"></br>
            </h2>
          </div>
          <div className="home-video-container">
            {/* <a
              href="https://www.youtube.com/channel/UCZwZO0248VoV5gaJIjPCexA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <video
                src="/playground_assets/XRecorder_Edited_15032023_012005.mp4"
                loop
                muted
                poster="/playground_assets/pastedimage-09r-900w.png"
                autoPlay
                className="home-video1"
              ></video>
            </a> */}
            <YouTubePlayer videoId="A5q8QH0QceE" />

            <div className="home-heading-container">
              <div className="home-heading">
                <span className="home-text03">
                  The app&apos;s explore page sorts people based on their
                  location and hobbies, prioritizing those who are closest to
                  the user initially and then gradually increasing the distance.
                </span>
                <span className="home-text04">
                  <br></br>
                  <span>
                    you can plan meets with your connections because Hobby
                    Connects have chat feature.
                  </span>
                  <br></br>
                </span>
              </div>
              <div className="home-explore">
                <a href="#feature" className="home-text08">
                  Explore more features  -&gt;
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-stats">
        <div className="home-stat">
          <span className="home-caption3">Abuse Free Chat</span>
          <span className="home-description">
            The app offers features to filter out abusive content and prevent
            bullying, allowing users to freely chat with strangers while
            ensuring a fast experience.
          </span>
        </div>
        <div className="home-stat1">
          <span className="home-caption4">
            Connect with people who have similar hobbies.
          </span>
          <span className="home-description1">
            The Explore page will suggest users according to user&apos;s
            interests.
          </span>
        </div>
      </div>
      <div className="home-sections">
        <div className="home-section">
          <div className="home-image">
            <div className="home-image-highlight">
              <span className="home-text09">Only necessary Info.</span>
            </div>
          </div>
          <div className="home-content2">
            <h2 className="home-text10">
              You can create a profile and update your details any number of
              times.
            </h2>
            <Highlight></Highlight>
            <Highlight
              Title="All users can see this info"
              Description="If you think you are not comfortable to fill your original so you can be anonymous too."
            ></Highlight>
            <div className="home-explore1">
              <a href="#feature" className="home-link1">
                Explore more features -&gt;
              </a>
            </div>
          </div>
        </div>
        <div className="home-section1">
          <div className="home-content3">
            <div className="home-heading1">
              <h2 className="home-text11">
                <span>Suggests Users based on your Hobbies.</span>
                <br className="home-text13"></br>
              </h2>
              <span className="home-text14">
                Get personalized suggestions of profiles who has similar
                interests and hobbies like you.
              </span>
            </div>
            <div className="home-content4">
              <div className="home-points">
                <Point></Point>
                <Point text="Based on Hobbies."></Point>
                <Point text="Can Connect with them, and Chat."></Point>
              </div>
              <Link to="/" className="home-navlink">
                <div className="home-get-started">
                  <span className="home-sign-up">Get started now</span>
                </div>
              </Link>
            </div>
          </div>
          <div className="home-image1"></div>
        </div>
        <div className="home-section2">
          <div className="home-image2">
            <div className="home-image-overlay"></div>
          </div>
          <div className="home-content5">
            <h2 className="home-text15">Fast and Abuse Filtered Chat</h2>
            <Accordion
              text="Fast and Responsive Chat"
              text1="You can only chat with your connects and vice versa."
              text2="Abusive words and Bullying Not Allowed "
              text3="As you can see in the pictures, if someone tries to use swear word so it will get covered with '*' symbols  and that user will get warning ⚠ "
              text4="Can use Emojis while chatting"
              text5="Hobby Connect's chat app supports all types of keyboards, fonts, text formation, etc."
            ></Accordion>
          </div>
        </div>
      </div>
      <div className="home-banner-container"></div>
      <div className="home-features">
        <div className="home-header2">
          <div className="home-tag">
            <span className="home-text16">Features</span>
          </div>
          <div className="home-heading2">
            <h2 className="home-text17">
              <span className="home-text18">
                Everything you get with Hobby Connect
              </span>
              <br className="home-text19"></br>
            </h2>
            <span className="home-text20">
              Connect with like-minded people, effortlessly
            </span>
          </div>
        </div>
        <div className="home-feature-list">
          <Feature Description="Create account to use, it only requires email and password."></Feature>
          <Feature
            Title="Multiple Devices"
            Thumbnail="/playground_assets/vector6113-r6dl.svg"
            Description="You can login your account from any another device."
          ></Feature>
          <Feature
            Title="Explore"
            Thumbnail="/playground_assets/vector6114-6m1e.svg"
            Description="Connect and Chat with strangers"
          ></Feature>
          <Feature
            Title="Safe Chat"
            Thumbnail="/playground_assets/vector6114-yjl.svg"
            Description="We provide welcoming and friendly environment."
          ></Feature>
        </div>
      </div>
      <div className="home-get-started1">
        <div className="home-content6">
          <div className="home-heading3">
            <h2 className="home-text21">
              <span>I have used React Native to Build.</span>
              <br className="home-text23"></br>
            </h2>
            <span className="home-text24">
              For Backend and Database I have used Google&apos;s Firebase and
              for location access, I&apos;m using React Native Geolocation
              service.
            </span>
          </div>
          <div className="home-hero-buttons1">
            <div className="home-io-btn1">
              <img
                alt="pastedImage"
                src="/playground_assets/pastedimage-zmzg.svg"
                className="home-apple1"
              />
              <span className="home-caption5">
                Download for iOS (not working)
              </span>
            </div>
            <a
              href="https://drive.google.com/file/d/16GS-vHQTlNL2SxX79-wNZJY7ViT2JVk8/view?usp=share_link"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link2"
            >
              <div className="home-android-btn1">
                <img
                  alt="pastedImage"
                  src="/playground_assets/pastedimage-ld65.svg"
                  className="home-android1"
                />
                <span className="home-caption6">Download for Android</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
